import CityPageTemplate from "../city-template/CityPageTemplate";
import { woosterConfig } from "./data";

export default function WoosterPage() {
  return <CityPageTemplate config={woosterConfig} />;
}